import styled from "@emotion/styled";
import { COLORS } from "../header/header.styled";

export const Container = styled.div<{ focused: boolean }>`
    height: 36px;
    display: flex;
    align-items: center;
    border-bottom: 2px solid ${(
        { focused },
    ) => (focused ? "#5E84ED" : "#2B2D33")};
    font-family:
        Inter,
        system-ui,
        -apple-system,
        Segoe UI,
        Roboto,
        Helvetica,
        Arial,
        "Apple Color Emoji",
        "Segoe UI Emoji";
    font-weight: 400;
    font-size: 14px;
    line-height: 120%;
`;

export const Icon = styled.span`
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Input = styled.input`
    flex: 1;
    height: 100%;
    border: none;
    outline: none;
    text-align: left;
    font: inherit;
    background: ${COLORS.surface};
    color: #b7bdcb;
`;

export const ClearButton = styled.button`
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
`;
